module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Healy_Hauerwas5#toc4"
    }
  }, [_vm._v("Abbreviations for Books by Stanley Hauerwas")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("The following lists only the books cited here; it is not an exhaustive list of Hauerwas’s works. The abbreviations are consistent with those in the "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Hauerwas Reader.")])]), _vm._v(" "), _c('p', {
    staticClass: "AB para-style-override-3"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("AC")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("After Christendom? How the Church Is to Behave If Freedom, Justice, and a Christian Nation Are Bad Ideas. ")]), _vm._v("Nashville: Abingdon Press, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("AN")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Against the Nations: War and Survival in a Liberal Society. ")]), _vm._v("Notre Dame: University of Notre Dame Press, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("BH")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("A Better Hope: Resources for a Church Confronting Capitalism, Democracy, and Postmodernity. ")]), _vm._v("Grand Rapids: Brazos Press, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("CC")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("A Community of Character: Toward a Constructive Christian Social Ethic. ")]), _vm._v("Notre Dame: University of Notre Dame Press, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("CCL")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Character and the Christian Life: A Study in Theological Ethics. ")]), _vm._v("San Antonio: Trinity University Press, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("CE")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("The Blackwell Companion to Christian Ethics. ")]), _vm._v("Ed. Stanley Hauerwas and Samuel Wells. Oxford: Blackwell, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("CET")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Christian Existence Today. ")]), _vm._v("Grand Rapids: Brazos Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("CSC")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("A Cross-­Shattered Church: Reclaiming the Theological Heart of Preaching. ")]), _vm._v("Grand Rapids: Brazos Press, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("DF")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Dispatches from the Front: Theological Engagements with the Secular. ")]), _vm._v("Durham, NC: Duke University Press, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("HC")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Hannah’s Child: A Theologian’s Memoir. ")]), _vm._v("Grand Rapids: Eerdmans, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("IGC")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("In Good Company: The Church as Polis. ")]), _vm._v("Notre Dame: University of Notre Dame Press, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("LGVW")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Living Gently in a Violent World. ")]), _vm._v("Stanley Hauerwas and Jean Vanier. Downers Grove, IL: InterVarsity Press, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("MC")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Matthew, ")]), _vm._v("Commentary on. Grand Rapids: Brazos Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("NS")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Naming the Silences: God, Medicine, and the Problem of Suffering. ")]), _vm._v("Grand Rapids: Eerdmans, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("PF")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Performing the Faith: Bonhoeffer and the Practice of Non-­Violence. ")]), _vm._v("Grand Rapids: Brazos Press, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("PK")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("The Peaceable Kingdom. ")]), _vm._v("Notre Dame: University of Notre Dame Press, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("R")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("The Hauerwas Reader. ")]), _vm._v("Edited by John Berkman and Michael Cartwright. Durham, NC: Duke University Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("RA")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Resident Aliens: Life in the Christian Colony. ")]), _vm._v("Nashville: Abingdon Press, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("STT")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Sanctify Them in the Truth: Holiness Exemplified. ")]), _vm._v("Nashville: Abingdon Press, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("SU")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("The State of the University: Academic Knowledges and the Knowledge of God. ")]), _vm._v("Oxford: Blackwell, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("TT")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Truthfulness and Tragedy: Further Investigations in Christian Ethics. ")]), _vm._v("Notre Dame: University of Notre Dame Press, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("US")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Unleashing the Scripture: Freeing the Bible from Captivity to America. ")]), _vm._v("Nashville: Abingdon Press, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("VV")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Vision and Virtue. ")]), _vm._v("Notre Dame: Fides, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("WAD")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("War and the American Difference: Theological Reflections on Violence and National Identity. ")]), _vm._v("Grand Rapids: Baker Academic, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("WGU")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("With the Grain of the Universe: The Church’s Witness and Natural Theology. ")]), _vm._v("Grand Rapids: Brazos Press, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "AB"
  }, [_c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("WWW")]), _vm._v(" "), _c('em', {
    staticClass: "italic char-style-override-1"
  }, [_vm._v("Working with Words. ")]), _vm._v("Eugene, OR: Cascade, 2011.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a18f05a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Healy_Hauerwas-7.vue
// module id = 78
// module chunks = 0